import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, AbstractControl, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TaskCreateComponent } from '../task-create/task-create.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { VisationModalComponent } from '../../../notifications/visation-modal/visation-modal.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
  selector: 'app-stage-create',
  templateUrl: './stage-create.component.html',
  styleUrls: ['./stage-create.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatExpansionModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    TaskCreateComponent,
    MatCheckboxModule,
    VisationModalComponent,
    MatDialogModule,
    MatNativeDateModule,
  ],
})
export class StageCreateComponent implements OnInit {
  @Input() isMaintenanceUpdate: boolean = false;
  @Input() index!: number;
  @Input() formGroup!: FormGroup;
  @Input() tasks: any[] = [];
  @Input() acceptanceCriterias: any[] = [];
  @Output() remove = new EventEmitter<void>();

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {}

  get tasksFormArray(): FormArray {
    return this.formGroup.get('tasks') as FormArray;
  }

  addTask() {
    this.tasksFormArray.push(
      this.fb.group({
        taskId: [null, Validators.required],
        taskName: [''],
        order: [null, Validators.required],
        required: [false],
        elements: this.fb.array([]),
        acceptanceCriterias: this.fb.array([]),
        visation: this.fb.group({
          id: [null], // Asegura que incluya el campo `id`
          effectiveDate: this.isMaintenanceUpdate ? ['', Validators.required] : [''],
          visationActions: this.fb.group({
            id: [null], // ID de la acción
            observation: [''],
            filePath: [''],
            originalFileName: [''],
            action: this.fb.group({
              id: [null], // ID de la acción dentro de visationActions
              name: [''], // Nombre de la acción
            }),
          }),
        }),
      }),
    );
  }

  removeTask(index: number) {
    this.tasksFormArray.removeAt(index);
  }

  getFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  getAcceptanceCriteriaFormArray(taskIndex: number): FormArray {
    const taskGroup = this.tasksFormArray.at(taskIndex) as FormGroup;
    return taskGroup.get('acceptanceCriterias') as FormArray;
  }

  addAcceptanceCriteria(taskIndex: number) {
    const criteriaFormArray = this.getAcceptanceCriteriaFormArray(taskIndex);
    criteriaFormArray.push(
      this.fb.group({
        acceptanceCriteriaId: [null, Validators.required],
        acceptanceCriteriaName: [''],
        elements: this.fb.array([]),
      }),
    );
  }

  removeAcceptanceCriteria(taskIndex: number, criteriaIndex: number) {
    const criteriaFormArray = this.getAcceptanceCriteriaFormArray(taskIndex);
    criteriaFormArray.removeAt(criteriaIndex);
  }

  getAcceptanceCriteriaElementsFormArray(taskIndex: number, criteriaIndex: number): FormArray {
    const criteriaFormArray = this.getAcceptanceCriteriaFormArray(taskIndex);
    const criteriaGroup = criteriaFormArray.at(criteriaIndex) as FormGroup;
    return criteriaGroup.get('elements') as FormArray;
  }

  addElementToAcceptanceCriteria(taskIndex: number, criteriaIndex: number) {
    const elementsFormArray = this.getAcceptanceCriteriaElementsFormArray(taskIndex, criteriaIndex);
    elementsFormArray.push(
      this.fb.group({
        labelName: ['', Validators.required],
        elementType: [''],
        required: [false],
        options: this.fb.array([]),
      }),
    );
  }

  removeElementFromAcceptanceCriteria(
    taskIndex: number,
    criteriaIndex: number,
    elementIndex: number,
  ) {
    const elementsFormArray = this.getAcceptanceCriteriaElementsFormArray(taskIndex, criteriaIndex);
    elementsFormArray.removeAt(elementIndex);
  }

  updateAcceptanceCriteriaName(
    taskIndex: number,
    criteriaIndex: number,
    acceptanceCriteriaId: number,
  ) {
    const acceptanceCriteria = this.acceptanceCriterias.find(a => a.id === acceptanceCriteriaId);
    if (acceptanceCriteria) {
      this.getAcceptanceCriteriaFormArray(taskIndex)
        .at(criteriaIndex)
        .get('acceptanceCriteriaName')
        ?.setValue(acceptanceCriteria.name);
    }
  }

  removeStage() {
    this.remove.emit();
  }
}
